module.exports = __webpack_public_path__ + "static/media/logo_small_banner.e15b997b.jpg";